var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrazeinline = function SvgBrazeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#braze_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#212124",
    d: "M7.23 9.164c.13-1.251.915-2.27 1.832-2.27.916 0 1.41 1.019 1.28 2.27-.131 1.25-.887 2.283-1.746 2.283-.858 0-1.556-.785-1.367-2.283M8 14.836a6.82 6.82 0 0 1-5.265-2.472c1.134.363 2.4.043 3.389-.931q.156-.158.29-.335c.451.975 1.324 1.47 2.197 1.47 1.484 0 2.734-1.528 2.88-3.419.145-1.89-.916-3.389-2.327-3.389a2.75 2.75 0 0 0-1.455.393l.436-2.546a.71.71 0 0 0-.13-.582c-.131-.203-.248-.29-.422-.29H5.556a.25.25 0 0 0-.232.218q-.081.36-.117.727c-.014.16.102.218.233.218h1.484a398 398 0 0 1-.83 4.99 3.6 3.6 0 0 1-.945 1.788c-.814.815-2.313 1.004-3.2.117-.305-.32-.785-1.106-.785-2.793A6.836 6.836 0 1 1 8 14.836M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "braze_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgBrazeinline;